export default "__VITE_ASSET__9a451336__"